import { useSelector } from "react-redux";

export const useFormEventStore = () => {
  const { isLoading, message } = useSelector(
    (state) => state.patient.formEvent
  );

  return {
    // Props
    isLoading,
    message,
  };
};
